import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addMessage, deleteMessage, updateMessage } from "../../../../store/redux/entities-action";
import { sendActionEvent } from "../../../../utils/analytics/ga4";
import boardType from "../../../../enums/boardType";
import targetGroupType from "../../../../enums/targetGroupType";
import ScheduleTabContentUI from "./ScheduleTabContentUI";

const SCHEDULE_MAX_IMAGE_BYTES = 500 * 1024;

const ScheduleTabContentPrivate = ({ scheduleEntities = [], texts = {}, scheduleFile, setScheduleFile, onClose }) => {

    const dispatch = useDispatch();
    const entity = scheduleEntities.find((entity) => !entity.nmmIds?.length);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const imageFile = scheduleFile !== undefined ? scheduleFile : (entity?.imageFile ?? null);
    const pendingDelete = scheduleFile === null && Boolean(entity?.id);

    const handleImageChange = (file) => {
        if (file === null) {
            setScheduleFile(null);
            return;
        }
        setScheduleFile(file);
    };

    const handleSave = async () => {
        if (isSubmitting)
            return;
        setIsSubmitting(true);
        const actionValue = pendingDelete ? "delete" : entity?.id ? "edit" : "add";
        sendActionEvent("schedule", actionValue);
        try {
            if (pendingDelete) {
                const result = await dispatch(deleteMessage({ id: entity.id }));
                if (result?.ok)
                    onClose?.();
                else
                    console.error("handleSave delete", result?.error);
                return;
            }

            if (!(scheduleFile instanceof File))
                return;
            const payload = {
                id: entity?.id ?? null,
                boardId: boardType.schedule,
                messageContents: [
                    { lang: "", content: "", imageFile: scheduleFile },
                ],
                tags: ["user"],
                messageFilters: [
                    {
                        studyGroupId: null,
                        targetGroup: targetGroupType.Private,
                    },
                ],
            };
            const result = entity?.id ? await dispatch(updateMessage(payload)) : await dispatch(addMessage(payload));
            if (result?.ok)
                onClose?.();
            else
                console.error("handleSave", result?.error);
        }
        catch (error) {
            console.error("handleSave", error);
        }
        finally {
            setIsSubmitting(false);
        }
    };

    return (
        <ScheduleTabContentUI
            texts={texts}
            imageFile={imageFile}
            onImageChange={handleImageChange}
            hasImage={Boolean(imageFile)}
            pendingDelete={pendingDelete}
            maxSizeBytes={SCHEDULE_MAX_IMAGE_BYTES}
            publishDisabled={isSubmitting || !(scheduleFile instanceof File || pendingDelete)}
            isSubmitting={isSubmitting}
            onClose={onClose}
            onSave={handleSave}
        />
    );
};

export default ScheduleTabContentPrivate;
